export default __webpack_public_path__ + "static/media/abt_mobile.64204eaa.jpg";